export default __webpack_public_path__ + "static/media/empty_data.857dff24.png";